module.exports = require('./modules/hawk');



// WEBPACK FOOTER //
// ./src/main.js